import script from "./message-plugin-web.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-plugin-web.vue?vue&type=script&lang=ts&setup=true"

import "./message-plugin-web.vue?vue&type=style&index=0&id=368b2b39&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-368b2b39"]])

export default __exports__